// Generated by scripts/referentiel/extract.mjs — do not edit by hand.
//
// Référentiel d’éducation physique et à la santé
// https://ifpc-fwb.be/v5/documents/tc/refEPS.pdf
// SHA-256 5299dfc69e9e1e3010c2db211dd12a527a1171005d7f658e3d6d04501235fcf0
// P3: pages 41-49, extractor v1

import type { Attendu } from './types.ts';

export const ATTENDUS: readonly Attendu[] = [
  {
    id: "EPS-P3-e6dc47a7",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "SCHÉMA CORPOREL ET LATÉRALISATION",
    kind: "Savoir",
    parent: "Connaitre les parties du corps (segments et articulations).",
    text: "Nommer le vocabulaire du corps.",
  },
  {
    id: "EPS-P3-e5725801",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "SCHÉMA CORPOREL ET LATÉRALISATION",
    kind: "Savoir",
    parent: "Connaitre les parties du corps (segments et articulations).",
    text: "Décrire une position ou un mouvement (il fléchit les jambes, il lève les mains…).",
  },
  {
    id: "EPS-P3-c23acf7f",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "SCHÉMA CORPOREL ET LATÉRALISATION",
    kind: "Savoir",
    parent: "Connaitre sa latéralité.",
    text: "Affirmer sa latéralité.",
  },
  {
    id: "EPS-P3-c1de25a9",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "SCHÉMA CORPOREL ET LATÉRALISATION",
    kind: "Savoir-faire",
    parent: "Exercer sa latéralité dans la réalisation de grands mouvements.",
    text: "Localiser et percevoir le corps et les parties du corps dans l’espace. (Intériorisation de l’image corporelle).",
  },
  {
    id: "EPS-P3-b6180a42",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "SCHÉMA CORPOREL ET LATÉRALISATION",
    kind: "Savoir-faire",
    parent: "Exercer sa latéralité dans la réalisation de grands mouvements.",
    text: "Exercer la notion de gauche et droite à celle des autres et lors de déplacements (je passe à gauche de Pierre, je contourne les cônes par la gauche puis par la droite…).",
  },
  {
    id: "EPS-P3-b65ed2b7",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "SCHÉMA CORPOREL ET LATÉRALISATION",
    kind: "Compétence",
    parent: "Exercer sa latéralité dans la réalisation de grands mouvements.",
    text: "Exploiter la connaissance de son corps pour choisir les mouvements adéquats (pied d’impulsion, choix du type de battues, ajustement postural…) dans des situations variées.",
  },
  {
    id: "EPS-P3-b01db30a",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "MOTRICITÉ GLOBALE : LES GRANDS MOUVEMENTS DE DÉPLACEMENTS, LES POSITIONS ET LE GAINAGE",
    kind: "Savoir",
    parent: "Maitriser et enchainer des grands mouvements fondamentaux.",
    text: "Nommer le vocabulaire des mouvements et des positions lié à l’activité (flexion, extension, en appui, en suspension…).",
  },
  {
    id: "EPS-P3-d1c3cc61",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "MOTRICITÉ GLOBALE : LES GRANDS MOUVEMENTS DE DÉPLACEMENTS, LES POSITIONS ET LE GAINAGE",
    kind: "Savoir-faire",
    parent: "Connaitre le vocabulaire des actions motrices et des positions.",
    text: "Exercer avec fluidité les grands mouvements fondamentaux.",
  },
  {
    id: "EPS-P3-8150a6b9",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "MOTRICITÉ GLOBALE : LES GRANDS MOUVEMENTS DE DÉPLACEMENTS, LES POSITIONS ET LE GAINAGE",
    kind: "Savoir-faire",
    parent: "Adapter ses mouvements aux circonstances et aux consignes.",
    text: "Combiner deux actions motrices simples (courir et tourner…).",
  },
  {
    id: "EPS-P3-ea9d6cf1",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "MOTRICITÉ GLOBALE : LES GRANDS MOUVEMENTS DE DÉPLACEMENTS, LES POSITIONS ET LE GAINAGE",
    kind: "Savoir-faire",
    parent: "Adapter ses mouvements aux circonstances et aux consignes.",
    text: "Modifier son tonus musculaire (se relâcher, contracter…).",
  },
  {
    id: "EPS-P3-f933c305",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "MOTRICITÉ GLOBALE : LES GRANDS MOUVEMENTS DE DÉPLACEMENTS, LES POSITIONS ET LE GAINAGE",
    kind: "Compétence",
    parent: "Adapter les grands mouvements fondamentaux aux contraintes du milieu dans des situations variées.",
    text: "Se déplacer avec efficacité sur différents supports (stable, instable, régulier, irrégulier…).",
  },
  {
    id: "EPS-P3-c4f4e6e1",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "MOTRICITÉ GLOBALE : LES GRANDS MOUVEMENTS DE DÉPLACEMENTS, LES POSITIONS ET LE GAINAGE",
    kind: "Compétence",
    parent: "Adapter les grands mouvements fondamentaux aux contraintes du milieu dans des situations variées.",
    text: "Ajuster les grands mouvements fondamentaux de déplacements en fonction de consignes.",
  },
  {
    id: "EPS-P3-a3a6cd60",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "MOTRICITÉ GLOBALE : LES GRANDS MOUVEMENTS DE DÉPLACEMENTS, LES POSITIONS ET LE GAINAGE",
    kind: "Compétence",
    parent: "Adapter les grands mouvements fondamentaux aux contraintes du milieu dans des situations variées.",
    text: "Adapter son tonus musculaire en fonction des caractéristiques de l’action (durée, vitesse, amplitude…).",
  },
  {
    id: "EPS-P3-54206500",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "MOTRICITÉ GLOBALE AVEC MANIPULATION D’OBJETS MOTRICITÉ FINE AVEC MANIPULATION D’OBJETS",
    kind: "Savoir",
    parent: "Connaitre le vocabulaire des objets utilisés et des actions sur ceux-ci.",
    text: "Nommer les objets utilisés et les actions sur ceux-ci.",
  },
  {
    id: "EPS-P3-019a0623",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "MOTRICITÉ GLOBALE AVEC MANIPULATION D’OBJETS MOTRICITÉ FINE AVEC MANIPULATION D’OBJETS",
    kind: "Savoir-faire",
    parent: "Connaitre le vocabulaire des objets utilisés et des actions sur ceux-ci.",
    text: "Réaliser les actions : manipuler, propulser, déplacer, réceptionner, contrôler, prendre, tirer, transporter, tenir, saisir, attraper, lancer, dribbler, jongler…",
  },
  {
    id: "EPS-P3-fd201aa5",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "MOTRICITÉ GLOBALE AVEC MANIPULATION D’OBJETS MOTRICITÉ FINE AVEC MANIPULATION D’OBJETS",
    kind: "Compétence",
    parent: "Exercer la coordination de mouvements et de manipulation d’objets.",
    text: "Dans des situations complexifiées : Adapter ses mouvements en vue d’agir sur des objets.",
  },
  {
    id: "EPS-P3-eb7c4582",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "MOTRICITÉ GLOBALE AVEC MANIPULATION D’OBJETS MOTRICITÉ FINE AVEC MANIPULATION D’OBJETS",
    kind: "Compétence",
    parent: "Coordonner et enchainer des mouvements et des gestes avec manipulation d’objets pour finaliser une action globale.",
    text: "Adapter ses mouvements en vue de réaliser des tâches de la vie quotidienne.",
  },
  {
    id: "EPS-P3-e005ba81",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "ÉQUILIBRE",
    kind: "Savoir-faire",
    parent: "Coordonner et enchainer des mouvements et des gestes avec manipulation d’objets pour finaliser une action globale.",
    text: "Maintenir et rétablir son équilibre en positionnant son centre de gravité, ses bras, en fixant son regard, en ajustant son tonus musculaire, ses appuis, sa surface de contact.",
  },
  {
    id: "EPS-P3-64f8e038",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "ÉQUILIBRE",
    kind: "Compétence",
    parent: "Exercer les techniques d’équilibre en situations dynamiques et statiques plus complexes.",
    text: "Gérer équilibres et déséquilibres dans des situations plus complexes et dans des milieux différents.",
  },
  {
    id: "EPS-P3-5a654d63",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "ESPACE, TEMPS ET RYTHME DE L’ACTION",
    kind: "Savoir",
    parent: "Connaitre le vocabulaire spatial associé à l’activité.",
    text: "Nommer et distinguer les repères spatiaux liés à l’activité.",
  },
  {
    id: "EPS-P3-a960779f",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "ESPACE, TEMPS ET RYTHME DE L’ACTION",
    kind: "Savoir",
    parent: "Connaitre des symboles spatiaux spécifiques.",
    text: "Nommer et distinguer les repères temporels liés à l’activité.",
  },
  {
    id: "EPS-P3-1467673e",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "ESPACE, TEMPS ET RYTHME DE L’ACTION",
    kind: "Savoir",
    parent: "Connaitre le vocabulaire spatiotemporel associé à l’activité (accélération, changement de rythmes…).",
    text: "Nommer le vocabulaire spatiotemporel lié à l’activité.",
  },
  {
    id: "EPS-P3-3ec30424",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "ESPACE, TEMPS ET RYTHME DE L’ACTION",
    kind: "Savoir-faire",
    parent: "Évoluer dans l’espace déterminé.",
    text: "Se déplacer en fonction de points de repère concrets fixes ou mobiles (obstacles, objets et personnes fixes ou mobiles).",
  },
  {
    id: "EPS-P3-15341ebe",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "ESPACE, TEMPS ET RYTHME DE L’ACTION",
    kind: "Savoir-faire",
    parent: "Évoluer dans l’espace déterminé.",
    text: "Se repérer dans l’espace connu en fonction de sa représentation (lecture de schémas, plans (circuits)…) et inversement.",
  },
  {
    id: "EPS-P3-c260562b",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "ESPACE, TEMPS ET RYTHME DE L’ACTION",
    kind: "Savoir-faire",
    parent: "Évoluer dans l’espace déterminé.",
    text: "Représenter le cheminement réalisé.",
  },
  {
    id: "EPS-P3-cf75eeca",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "ESPACE, TEMPS ET RYTHME DE L’ACTION",
    kind: "Savoir-faire",
    parent: "Évoluer dans l’espace déterminé.",
    text: "Placer du matériel en fonction d’un plan.",
  },
  {
    id: "EPS-P3-33cca7cf",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "ESPACE, TEMPS ET RYTHME DE L’ACTION",
    kind: "Savoir-faire",
    parent: "Évoluer dans l’espace déterminé.",
    text: "S’adapter à un rythme extérieur seul ou à plusieurs.",
  },
  {
    id: "EPS-P3-d1f0c556",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "ESPACE, TEMPS ET RYTHME DE L’ACTION",
    kind: "Savoir-faire",
    parent: "Suivre différents rythmes.",
    text: "Découvrir ses rythmes personnels (rythmes de déplacement, battements du cœur, respiration…).",
  },
  {
    id: "EPS-P3-3fd63497",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "ESPACE, TEMPS ET RYTHME DE L’ACTION",
    kind: "Compétence",
    parent: "Suivre différents rythmes.",
    text: "S’orienter dans un espace connu en fonction des caractéristiques de celui-ci.",
  },
  {
    id: "EPS-P3-4a1fb6a9",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "ESPACE, TEMPS ET RYTHME DE L’ACTION",
    kind: "Compétence",
    parent: "Se repérer, se déplacer dans l’espace et le temps et le représenter.",
    text: "Ajuster le rythme de ses mouvements en fonction de l’action.",
  },
  {
    id: "EPS-P3-39be982e",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "ESPACE, TEMPS ET RYTHME DE L’ACTION",
    kind: "Compétence",
    parent: "Percevoir un rythme et l’exprimer par une action motrice.",
    text: "Traduire par le geste des structures rythmiques, seul ou en partenariat.",
  },
  {
    id: "EPS-P3-782dea0f",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "HME5 S’exprimer et communiquer à l’aide de son corps",
    kind: "Savoir-faire",
    parent: "Percevoir un rythme et l’exprimer par une action motrice.",
    text: "Imiter, mimer une attitude expressive.",
  },
  {
    id: "EPS-P3-3cc81c73",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "HME5 S’exprimer et communiquer à l’aide de son corps",
    kind: "Savoir-faire",
    parent: "Utiliser des gestes et des mouvements spontanés ou suggérés comme outil d’expression.",
    text: "Improviser seul ou en partenariat sur un thème, une idée, une musique…",
  },
  {
    id: "EPS-P3-e1dd0676",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "HME5 S’exprimer et communiquer à l’aide de son corps",
    kind: "Savoir-faire",
    parent: "Utiliser des gestes et des mouvements spontanés ou suggérés comme outil d’expression.",
    text: "Exécuter une chorégraphie simple sur une idée, un thème…",
  },
  {
    id: "EPS-P3-fb5b09fa",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "HME5 S’exprimer et communiquer à l’aide de son corps",
    kind: "Savoir-faire",
    parent: "Utiliser des gestes et des mouvements spontanés ou suggérés comme outil d’expression.",
    text: "Apprécier la production de pairs.",
  },
  {
    id: "EPS-P3-5112a0e6",
    champ: "CHAMP 1 : HABILETÉS MOTRICES ET EXPRESSION",
    section: "HME5 S’exprimer et communiquer à l’aide de son corps",
    kind: "Compétence",
    parent: "S’exprimer et communiquer à l’aide de son corps.",
    text: "Présenter des séquences expressives simples.",
  },
  {
    id: "EPS-P3-f15a6c14",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "RESPECT DES RÈGLES, RÔLES ET BUTS",
    kind: "Savoir",
    parent: "S’exprimer et communiquer à l’aide de son corps.",
    text: "Énoncer les règles liées à l’activité.",
  },
  {
    id: "EPS-P3-9db074fe",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "RESPECT DES RÈGLES, RÔLES ET BUTS",
    kind: "Savoir",
    parent: "Connaitre les consignes liées à l’activité.",
    text: "Identifier le but à atteindre.",
  },
  {
    id: "EPS-P3-74c17983",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "RESPECT DES RÈGLES, RÔLES ET BUTS",
    kind: "Savoir",
    parent: "Connaitre le but à atteindre.",
    text: "Identifier les rôles à assumer (attaquant, défenseur, gardien, voltigeur, garant, relayeur…).",
  },
  {
    id: "EPS-P3-eebe2961",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "RESPECT DES RÈGLES, RÔLES ET BUTS",
    kind: "Savoir-faire",
    parent: "Connaitre les différents rôles à assumer.",
    text: "Accepter les règles.",
  },
  {
    id: "EPS-P3-b3762cd4",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "RESPECT DES RÈGLES, RÔLES ET BUTS",
    kind: "Savoir-faire",
    parent: "Appliquer des règles liées à l’activité.",
    text: "Participer à l’élaboration de règles communes.",
  },
  {
    id: "EPS-P3-ae87394f",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "RESPECT DES RÈGLES, RÔLES ET BUTS",
    kind: "Savoir-faire",
    parent: "Appliquer des règles liées à l’activité.",
    text: "Respecter les règles.",
  },
  {
    id: "EPS-P3-98f438eb",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "RESPECT DES RÈGLES, RÔLES ET BUTS",
    kind: "Savoir-faire",
    parent: "Exercer différents rôles",
    text: "Assumer différents rôles.",
  },
  {
    id: "EPS-P3-ac9ebbdd",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "RESPECT DES RÈGLES, RÔLES ET BUTS",
    kind: "Compétence",
    parent: "Exercer différents rôles",
    text: "Se comporter en respectant des règles.",
  },
  {
    id: "EPS-P3-d9a5b432",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "RESPECT DES RÈGLES, RÔLES ET BUTS",
    kind: "Compétence",
    parent: "Respecter des règles convenues dans l’intérêt du groupe et de chacun en fonction du but à atteindre.",
    text: "Ajuster son action en fonction du but à atteindre.",
  },
  {
    id: "EPS-P3-e2a8ec55",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "HSC2 Contribuer activement à la construction d’une réalisation commune",
    kind: "Savoir",
    parent: "Respecter des règles convenues dans l’intérêt du groupe et de chacun en fonction du but à atteindre.",
    text: "Se faire comprendre, comprendre les messages des autres.",
  },
  {
    id: "EPS-P3-2c196b61",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "HSC2 Contribuer activement à la construction d’une réalisation commune",
    kind: "Savoir",
    parent: "Connaitre les principes de communication : être compris, être réceptif aux messages des autres.",
    text: "Repérer les signaux pertinents à observer (environnement, partenaires de jeu).",
  },
  {
    id: "EPS-P3-9e24f68f",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "HSC2 Contribuer activement à la construction d’une réalisation commune",
    kind: "Savoir",
    parent: "Reconnaitre les signaux de l’environnement (repères du terrain) ou émis par des partenaires.",
    text: "Expliquer les stratégies de jeu et ses choix d’action.",
  },
  {
    id: "EPS-P3-30e6f0ad",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "HSC2 Contribuer activement à la construction d’une réalisation commune",
    kind: "Savoir-faire",
    parent: "Connaitre des stratégies de jeux.",
    text: "Agir en fonction des signaux perçus dans l’environnement ou émis par son ou ses partenaire(s) : repérer des espaces libres et s’y positionner, aider son ou ses partenaire(s), se signaler…",
  },
  {
    id: "EPS-P3-dfad5145",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "HSC2 Contribuer activement à la construction d’une réalisation commune",
    kind: "Compétence",
    parent: "Contribuer activement à la construction d’une réalisation commune.",
    text: "Adapter son action à celle des partenaires en fonction du but poursuivi.",
  },
  {
    id: "EPS-P3-b79b266d",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "HSC3 Interagir positivement avec ses partenaires S’affirmer en respectant les autres (assertivité, vigilance aux stéréotypes…)",
    kind: "Savoir",
    parent: ".",
    text: "Nommer les attitudes fair-play.",
  },
  {
    id: "EPS-P3-cba48b49",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "HSC3 Interagir positivement avec ses partenaires S’affirmer en respectant les autres (assertivité, vigilance aux stéréotypes…)",
    kind: "Savoir",
    parent: ".",
    text: "Respecter les autres : écouter, attendre son tour, encourager, s’exprimer en utilisant un langage verbal et non verbal correct, aider, accepter de perdre et savoir gagner, faire preuve d’honnêteté, accepter les différences* et les erreurs…",
  },
  {
    id: "EPS-P3-f9aac41b",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "HSC3 Interagir positivement avec ses partenaires S’affirmer en respectant les autres (assertivité, vigilance aux stéréotypes…)",
    kind: "Savoir",
    parent: ".",
    text: "Respecter le matériel et l’infrastructure.",
  },
  {
    id: "EPS-P3-ff515022",
    champ: "CHAMP 2 : HABILETÉS SOCIOMOTRICES ET CITOYENNETÉ",
    section: "HSC3 Interagir positivement avec ses partenaires S’affirmer en respectant les autres (assertivité, vigilance aux stéréotypes…)",
    kind: "Compétence",
    parent: ".",
    text: "Adopter un comportement fair-play : maitrise de soi, bienveillance, respect, tolérance…",
  },
  {
    id: "EPS-P3-a6d5d335",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS1 Adopter un style de vie sain et actif, être activement responsable de sa condition physique",
    kind: "Savoir",
    parent: "Découvrir les grands principes liés à une bonne hygiène de vie (hygiène, alimentation, hydratation, sommeil, activité physique, évitement de la sédentarité…).",
    text: "Identifier de bonnes habitudes de vie en matière d’alimentation, hydratation, sommeil, hygiène…",
  },
  {
    id: "EPS-P3-4b90c70e",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS1 Adopter un style de vie sain et actif, être activement responsable de sa condition physique",
    kind: "Savoir",
    parent: "Découvrir les grands principes liés à une bonne hygiène de vie (hygiène, alimentation, hydratation, sommeil, activité physique, évitement de la sédentarité…).",
    text: "Énoncer des bienfaits liés à la pratique quotidienne d’activités physiques.",
  },
  {
    id: "EPS-P3-b30d0eab",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS1 Adopter un style de vie sain et actif, être activement responsable de sa condition physique",
    kind: "Savoir",
    parent: "Comprendre le fonctionnement du corps à l’effort et au repos, à travers la prise de la fréquence cardiaque.",
    text: "Situer les endroits du corps pour la prise de la fréquence cardiaque.",
  },
  {
    id: "EPS-P3-6dcea60f",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS1 Adopter un style de vie sain et actif, être activement responsable de sa condition physique",
    kind: "Savoir-faire",
    parent: "Expérimenter des facteurs de la condition physique, à travers des activités physiques variées : endurance, souplesse, force.",
    text: "Comparer ses sensations corporelles à l’effort, dans les étirements et au repos.",
  },
  {
    id: "EPS-P3-63db6046",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS1 Adopter un style de vie sain et actif, être activement responsable de sa condition physique",
    kind: "Savoir-faire",
    parent: "Expérimenter des facteurs de la condition physique, à travers des activités physiques variées : endurance, souplesse, force.",
    text: "Adapter ses efforts à un rythme donné par le professeur. Être actif (jouer, courir, marcher activement, danser…) 80 % de la séance.",
  },
  {
    id: "EPS-P3-9e022be2",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS1 Adopter un style de vie sain et actif, être activement responsable de sa condition physique",
    kind: "Savoir-faire",
    parent: "Expérimenter des facteurs de la condition physique, à travers des activités physiques variées : endurance, souplesse, force.",
    text: "Effectuer des efforts longs (courir, marcher activement, danser…) de faible intensité de fréquence cardiaque et à un rythme régulier.",
  },
  {
    id: "EPS-P3-155772b6",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS1 Adopter un style de vie sain et actif, être activement responsable de sa condition physique",
    kind: "Compétence",
    parent: "Expérimenter des facteurs de la condition physique, à travers des activités physiques variées : endurance, souplesse, force.",
    text: "S’impliquer dans les activités de développement de la condition physique.",
  },
  {
    id: "EPS-P3-9703169d",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS2 Être activement responsable de sa sécurité et de celle des autres en salle, en milieux naturel, urbain et aquatique",
    kind: "Savoir",
    parent: "Connaitre le numéro d’appel d’urgence.",
    text: "Citer le numéro d’appel d’urgence : 112.",
  },
  {
    id: "EPS-P3-b7de6036",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS2 Être activement responsable de sa sécurité et de celle des autres en salle, en milieux naturel, urbain et aquatique",
    kind: "Savoir",
    parent: "Penser à sa sécurité et celle des autres lors d’un accident, afin d’éviter le sur-accident.",
    text: "Repérer les dangers potentiels de l’environnement.",
  },
  {
    id: "EPS-P3-3edcd992",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS2 Être activement responsable de sa sécurité et de celle des autres en salle, en milieux naturel, urbain et aquatique",
    kind: "Savoir-faire",
    parent: "Découvrir des actions préventives pour éviter des blessures et des accidents, lors de sa participation aux activités physiques (port du casque, tenue adéquate, s’échauffer, s’étirer, manutention, postures adéquates…).",
    text: "Adopter les postures appropriées aux positions assise et debout.",
  },
  {
    id: "EPS-P3-25078f1f",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS2 Être activement responsable de sa sécurité et de celle des autres en salle, en milieux naturel, urbain et aquatique",
    kind: "Savoir-faire",
    parent: "Exercer les composantes de la sécurité aquatique : flottaison, propulsion, immersion, respiration.",
    text: "En moyenne profondeur : - réaliser une flèche ventrale et dorsale avec ou sans aide à la flottabilité avec mouvements de jambes et/ou de bras ; - sauter du bord sans le tenir, flotter sur le dos et/ou sur le ventre sans aide à la flottabilité et revenir au bord en se propulsant à l’aide de mouvements de jambes et/ou des bras ; - souffler dans l’eau.",
  },
  {
    id: "EPS-P3-42d75140",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS2 Être activement responsable de sa sécurité et de celle des autres en salle, en milieux naturel, urbain et aquatique",
    kind: "Compétence",
    parent: "Exercer les composantes de la sécurité aquatique : flottaison, propulsion, immersion, respiration.",
    text: "Identifier, lors de sa participation à des activités physiques, des façons de prévenir des risques d’accident.",
  },
  {
    id: "EPS-P3-03e91b1c",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS3 Identifier ses émotions, mobiliser des techniques de gestion des émotions et du stress",
    kind: "Savoir",
    parent: "Connaitre le vocabulaire des émotions et des sensations liées à celles-ci (calme, détendu, crispé, joyeux, fier, confiant, peur…).",
    text: "Nommer le vocabulaire des émotions et des sensations liées à celles-ci (calme, détendu, crispé, joyeux, fier, confiant, peur…).",
  },
  {
    id: "EPS-P3-904ccd71",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS3 Identifier ses émotions, mobiliser des techniques de gestion des émotions et du stress",
    kind: "Savoir-faire",
    parent: "Percevoir les sensations physiques liées aux émotions : respiration, modification du tonus, sensation viscérale (maux de ventre, rythme cardiaque, sudation…).",
    text: "Exprimer les sensations physiques liées aux émotions : respiration, modification du tonus, sensation viscérale.",
  },
  {
    id: "EPS-P3-eabb8b61",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS3 Identifier ses émotions, mobiliser des techniques de gestion des émotions et du stress",
    kind: "Savoir-faire",
    parent: "Percevoir les sensations physiques liées aux émotions : respiration, modification du tonus, sensation viscérale (maux de ventre, rythme cardiaque, sudation…).",
    text: "Appliquer des techniques dirigées de gestion des émotions.",
  },
  {
    id: "EPS-P3-e35587dd",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS3 Identifier ses émotions, mobiliser des techniques de gestion des émotions et du stress",
    kind: "Compétence",
    parent: "Identifier ses émotions.",
    text: "Exprimer son vécu émotionnel de l’activité.",
  },
  {
    id: "EPS-P3-52e988e5",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS4 Construire une image positive de soi, développer son sentiment de compétence et plus largement son estime de soi à adopter un mode de vie sain et actif, dans et en dehors de l’école",
    kind: "Savoir-faire",
    parent: "Mobiliser des techniques de gestion des émotions.",
    text: "Exprimer son ressenti à l’égard de l’activité physique vécue.",
  },
  {
    id: "EPS-P3-f1efe7fc",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS4 Construire une image positive de soi, développer son sentiment de compétence et plus largement son estime de soi à adopter un mode de vie sain et actif, dans et en dehors de l’école",
    kind: "Compétence",
    parent: "Découvrir ses gouts et capacités en matière d’activité physique.",
    text: "Identifier ses forces en activité physique.",
  },
  {
    id: "EPS-P3-d3d631c1",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS4 Construire une image positive de soi, développer son sentiment de compétence et plus largement son estime de soi à adopter un mode de vie sain et actif, dans et en dehors de l’école",
    kind: "Compétence",
    parent: "Construire une image positive de soi, développer son sentiment de compétence et plus largement son estime de soi à adopter un mode de vie sain et actif, dans et en dehors de l’école.",
    text: "Reconnaitre, dans son milieu, les possibilités d’activité physique.",
  },
  {
    id: "EPS-P3-0b91bdb9",
    champ: "CHAMP 3 : GESTION DE SA SANTÉ ET DE LA SÉCURITÉ",
    section: "GSS5 Exercer sa pensée critique sur divers sujets liés à la santé et au bien-être",
    kind: "Compétence",
    parent: "Exercer sa pensée critique sur divers sujets liés à la santé et au bien-être.",
    text: "S’interroger et formuler des questions sur divers sujets liés à la santé.",
  },
];
